import { parseImageName, parseWidthHeight } from '../../utils/stringUtils';
var ImageDescriptor = /** @class */ (function () {
    function ImageDescriptor(descr) {
        this.descr = descr;
    }
    ImageDescriptor.prototype.getFullImageDescriptor = function () {
        try {
            if (!this.descr.relativeUrl && this.descr.url) {
                // get relative url from name
                this.descr.relativeUrl = parseImageName(this.descr.url);
            }
            if (!this.descr.sourceWidth || !this.descr.sourceHeight) {
                // get sourceWidth || sourceHeight from name
                var _a = parseWidthHeight(this.descr.url), width = _a.width, height = _a.height;
                this.descr.sourceWidth = width || this.descr.targetWidth || 100;
                this.descr.sourceHeight = height || this.descr.targetHeight || 100;
            }
        }
        catch (e) {
            console.log('Error in ImageDescriptor.setFullImageDescriptor', e);
        }
        return this.descr;
    };
    ImageDescriptor.fromUrl = function (url) {
        var descriptor = {
            targetHeight: 0,
            targetWidth: 0,
            url: url,
        };
        var imgD = new ImageDescriptor(descriptor);
        return imgD.getFullImageDescriptor();
    };
    return ImageDescriptor;
}());
export { ImageDescriptor };
//# sourceMappingURL=ImageDescriptor.js.map